import { ActorTreeView } from '../ActorTreeView';
import { EmptyState } from '../atoms/EmptyState';
import { ResizeHandle } from '../atoms/ResizeHandle';
import { cn } from '@/core/lib/utils';
import { ActorTree } from '../../types/actor-types';

interface TreePanelProps {
  isVisible: boolean;
  isResizing: boolean;
  width: number;
  actors: ActorTree[];
  selectedLocationId: string | null;
  shouldAutoScroll: boolean;
  onLocationSelect: (actorId: string) => void;
  onResize: (e: React.MouseEvent) => void;
}

/**
 * Molecule component for the resizable tree panel
 */
export function TreePanel({
  isVisible,
  isResizing,
  width,
  actors,
  selectedLocationId,
  shouldAutoScroll,
  onLocationSelect,
  onResize
}: TreePanelProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div 
      className={cn(
        "overflow-hidden relative",
        isResizing ? 'transition-none' : 'transition-all duration-300 ease-in-out',
        isVisible ? 'opacity-100' : 'w-0 opacity-0'
      )}
      style={{ width: `${width}px` }}
    >
      <div
        className="bg-white rounded-lg border flex flex-col"
        style={{ width: `${width}px`, height: 'calc(100vh - 220px)' }}
      >
        <div className="flex-1 h-full">
          {actors && actors.length > 0 ? (
            <ActorTreeView 
              actors={actors}
              selectedLocationId={selectedLocationId}
              onLocationSelect={onLocationSelect}
              shouldAutoScroll={shouldAutoScroll}
              className="h-full"
            />
          ) : (
            <EmptyState
              title="No actor tree available"
              description="Please select an operator first."
            />
          )}
        </div>
      </div>
      
      <ResizeHandle onMouseDown={onResize} />
    </div>
  );
}